import React from 'react'
import { colors } from 'ic-snacks'
import { type VictoryTooltipProps } from 'victory'
import { type ChartSeries, type Datum } from 'legacy/components/DataViz/dataViz.types'
import { getSeriesColor, NO_DATA_LABEL } from 'legacy/components/DataViz/Charts/utils'
import { CHART_PADDING_RIGHT } from 'legacy/components/DataViz/Charts/CommonChartStyles'
import LabelTooltip from './LabelTooltip'

interface Props extends VictoryTooltipProps {
  datum?: Datum
  scale?: {
    x: (value: number) => number
    y: (value: number) => number
  }
  text?: string[]
  series: ChartSeries[]
  renderLabelText(d: Datum): string
  chartWidth: number
  x?: number
}

const DotAndLabelTooltip: React.FC<Props> = props => {
  // Casting since had to make all props optional because of
  // Victory API for passing a label component....
  const { datum, scale, series, text, renderLabelText, chartWidth, x } = props as Required<Props>
  const xPosition = scale.x(datum.x)
  const yValues = text.map(n => (n === NO_DATA_LABEL ? null : parseFloat(n)))
  const labelText = series
    .map((n, i) => n.type !== 'last_period' && renderLabelText({ x: datum.x, y: yValues[i] }))
    .filter(Boolean) as string[]

  let { orientation } = props

  if (x && chartWidth - x <= CHART_PADDING_RIGHT) {
    orientation = 'left'
  }

  return (
    <React.Fragment>
      <g>
        <line
          x1={xPosition}
          x2={xPosition}
          y1="0"
          y2="260"
          stroke={colors.GRAY_74}
          strokeWidth={1}
        />
        {yValues.map(
          (yValue, index) =>
            yValue !== null && (
              <circle
                key={series[index].label}
                cx={xPosition}
                cy={scale.y(yValue)}
                r="5"
                fill={colors.WHITE}
                stroke={getSeriesColor(series[index].type)}
                strokeWidth="1.5px"
              />
            )
        )}
      </g>
      <LabelTooltip {...props} renderInPortal orientation={orientation} text={labelText} />
    </React.Fragment>
  )
}

export default DotAndLabelTooltip
